import React from 'react';
import { Modal } from 'react-bootstrap';

import './modals.style.css';

interface Props {
  isShow: boolean;
  title: string;
  children?: React.ReactNode;
  onHide: () => void;
}

export class CentreModal extends React.Component<Props> {
  render() {
    const { isShow, onHide, title, children } = this.props;

    return (
      <Modal size="sm" show={isShow} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    );
  }
}
